import moment from "moment-timezone";
import { weekOptions } from "../constants/constants";

export const convertTimeZone = (sourceTimezone, incommingDate, format) => {
    const userTimeZoneDate = moment.tz(incommingDate, sourceTimezone);
    const asiaTime = moment.tz(userTimeZoneDate, "Asia/Kolkata").format(format)
    return (asiaTime)
}

export const formatOrdinal = (num) => {
    if (num % 100 >= 11 && num % 100 <= 13) {
        return `${num}th`;
    }
    switch (num % 10) {
        case 1:
            return `${num}st`;
        case 2:
            return `${num}nd`;
        case 3:
            return `${num}rd`;
        default:
            return `${num}th`;
    }
};

export const weekformat = (md) => {
    const [values, week] = md.split("/");
    const formattedValues = values.split(",").map(q=>parseInt(q));
    const days= formattedValues?.length?weekOptions
    .filter(option =>formattedValues?.includes(option.value))
    .map(option => option.label):[]
    return `${days.toString()} of ${formatOrdinal(week)} week`;
}
